query TransactionPaymentTypes {
  transactionPaymentTypes(orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      transactionType
    }
  }
}
